import React from 'react';

/**
 * ResearcherTabs
 * - Renders the tab header for Researcher detail page.
 * - Props:
 *   - activeTab: number (0=Introduction, 1=Scholar Metrics, 2=Co-Researchers, 3=Resources)
 *   - onChange: (idx:number) => void
 */
export default function ResearcherTabs({ activeTab = 0, onChange }) {
  const setActive = (i) => { if (typeof onChange === 'function') onChange(i); };
  return (
    <div className="researcher-cont-tabM tabM mt-[30px] mx-[-24px] text-[15px] font-medium text-[#8D9AAF] text-center overflow-x-auto sm:overflow-x-hidden lg:mx-[-60px] lg:mt-[52px]">
      <div className="tab-wrapper w-max sm:w-full">
        <div className={`${activeTab === 0 ? 'active ' : ''}tab-intro relative border-b border-b-[#E4E8F1] sm:w-[25%] lg:hover:text-[#333]`}>
          <button id="introBtn" className="h-[52px] px-6 cursor-pointer" onClick={() => setActive(0)}>Introduction</button>
        </div>

        <div className={`${activeTab === 1 ? 'active ' : ''}border-b border-b-[#E4E8F1] sm:w-[25%] lg:hover:text-[#333]`}>
          <button className="h-[52px] px-6 cursor-pointer" onClick={() => setActive(1)}>
            Researcher Metrics
          </button>
        </div>

        <div className={`${activeTab === 2 ? 'active ' : ''}border-b border-b-[#E4E8F1] sm:w-[25%] lg:hover:text-[#333]`}>
          <button className="h-[52px] px-6 cursor-pointer" onClick={() => setActive(2)}>Co-Researchers</button>
        </div>

        <div className={`${activeTab === 3 ? 'active ' : ''}border-b border-b-[#E4E8F1] sm:w-[25%] lg:hover:text-[#333]`}>
          <button className="h-[52px] px-6 cursor-pointer" onClick={() => setActive(3)}>
            Publications
          </button>
        </div>
      </div>
    </div>
  );
}
